module.exports = __webpack_public_path__ + "media/images/wines/tempranillo-reserva/bottle-detail-2cf20ca699b7b04c27fca54f594e013a.png";